var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sale"},[_vm._v(" 套餐分析 ")])
}
var staticRenderFns = []

export { render, staticRenderFns }